/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCLeftIcon20Regular = forwardRef('ArrowCLeftIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.155 16.78a.75.75 0 0 1-1.06 0l-4.836-4.836a2.75 2.75 0 0 1 0-3.889l4.835-4.836a.75.75 0 0 1 1.061 1.061L8.32 9.116a1.25 1.25 0 0 0 0 1.768l4.836 4.836a.75.75 0 0 1 0 1.06Z" })));
});
